<div class="dashboard-chart">
    <div class="dashboard-chart__header">
        <h5>{{ title }}</h5>
        <!-- we will use this code later on the basis of condition, correnlty this will be commented out -->
        <!-- <button type="button" [ngClass]="buttonClass" (click)="onButtonClick()">{{ buttonLabel }}</button> -->
    </div>
    <div class="card-body pb-1"
        [hidden]="isShowImg">
        <img [alt]="altText"
            [src]="iconSrc" />
    </div>
    <div [hidden]="isShowContent">
    <div class="dashboard-chart__body">
        <ng-container>            
            <!-- Chart.js content goes here -->
             <canvas [id]="chartId"></canvas>
            <ng-content></ng-content>
        </ng-container>
    </div>
    <div class="dashboard-chart__footer">
        @for(item of footerItems; track item; let i = $index){<ng-container>
            <p><span class="chart-indicator" [ngClass]="item.indicatorClass"></span>{{ item.text }}</p>
        </ng-container>}
    </div>
    </div>   
    @if(isShowContent){<div class="dashboard-chart__footer" style="padding: 18px;"></div>}
</div>